
import router from "@/app/ui/router";
import { computed, defineComponent, onMounted, ref } from "vue";
import TabRiwayatFollowUp from "./tab-riwayat-follow-up.vue";
import TabRiwayatHanging from "./tab-riwayat-hanging.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: "PageHistoryHangingBKD",

  setup() {
    const { t } = useI18n();
    const tabs = computed(() => {
      return [
        {
          title: t("dashboard.hangingBkd.historyPage.tabs.historyHanging"),
          value: "history-hanging-bkd",
          component: TabRiwayatHanging
        },
        {
          title: t("dashboard.hangingBkd.historyPage.tabs.historyFollowUp"),
          value: "history-follow-up-bkd",
          component: TabRiwayatFollowUp
        }
      ]
    });

    const activeMenu = ref(tabs.value[0].value);

    const onChangeTabs = (value: string) => {
      activeMenu.value = value;
      router.push({ name: value });
    };

    const activeTabComponent = computed(() => {
      const current = tabs.value.find((tab) => tab.value === activeMenu.value);
      return current?.component || null;
    });

    onMounted(() => {
      const currentName = router.currentRoute.value.name as string;
      if (tabs.value.some((tab) => tab.value === currentName)) {
        activeMenu.value = currentName;
      }
    });

    return {
      activeMenu,
      activeTabComponent,
      tabs,
      onChangeTabs,
      isSidebarAndBreadcrumbV2: computed(
        () => MainAppController.isSidebarAndBreadcrumbV2
      )
    };
  }
});
